import { ref } from 'vue';

export default () => {
  const isSTRPressed = ref(false);

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Control' || e.key === 'Meta') {
      isSTRPressed.value = true;
    }
  };
  const handleKeyUp = (e: KeyboardEvent) => {
    if (e.key === 'Control' || e.key === 'Meta') {
      isSTRPressed.value = false;
    }
  };

  return { state: { isSTRPressed }, funcs: { handleKeyDown, handleKeyUp } };
};
